import { Controller } from "@hotwired/stimulus"

// Client-side draft for the announcement compose form. Persists subject/body to
// localStorage as the admin types, so leaving the page (e.g. to the history
// page) and coming back restores the in-progress message. Nothing is saved
// server-side — this is purely a convenience against accidental loss.
//
// Compose page (on the <form>):
//   data-controller="announcement-draft"
//   subject/body inputs:
//     data-announcement-draft-target="field"
//     data-action="input->announcement-draft#save"
//
// Confirm page (on the <form>):
//   data-controller="announcement-draft"
//   data-action="turbo:submit-end->announcement-draft#clearOnSuccess"
//   (clears the draft only once the send actually succeeds — a cancelled
//    confirm dialog or "Back to edit" 422 leaves it intact.)
export default class extends Controller {
  static targets = ["field"]
  static values  = { key: { type: String, default: "growerone:announcement-draft" } }

  connect() {
    this.restore()
  }

  // Persist every named field to a single localStorage entry, keyed by input name.
  save() {
    const draft = {}
    this.fieldTargets.forEach((field) => { draft[field.name] = field.value })
    try {
      window.localStorage.setItem(this.keyValue, JSON.stringify(draft))
    } catch (_e) {
      // localStorage unavailable (private mode / quota) — silently skip.
    }
  }

  // Fill blank fields from a stored draft. Never clobbers a value the server
  // already rendered (e.g. the re-rendered form after "Back to edit").
  restore() {
    if (!this.hasFieldTarget) return

    let draft
    try {
      draft = JSON.parse(window.localStorage.getItem(this.keyValue) || "null")
    } catch (_e) {
      return
    }
    if (!draft) return

    this.fieldTargets.forEach((field) => {
      if (!field.value && draft[field.name] != null) field.value = draft[field.name]
    })
  }

  clearOnSuccess(event) {
    if (event.detail?.success) this.clear()
  }

  clear() {
    try {
      window.localStorage.removeItem(this.keyValue)
    } catch (_e) {
      // ignore
    }
  }
}
